import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const DOMOrderSettingsComponent = ({ selectDOMSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3'>
                  <InputContainer
                    label="ReOrder Allow Enabled"
                    name="IsReOrderAllowEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsReOrderAllowEnabled',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsReOrderAllowEnabled}
                />
                <InputContainer
                    label="Complete Order When Delivered Enabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsCompleteOrderWhenDeliveredEnabled',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsCompleteOrderWhenDeliveredEnabled}
                />
                <InputContainer
                    label="Allow Admin To Buy Call For Price Products Enabled"
                    name="IsAllowAdminToBuyCallForPriceProductsEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsAllowAdminToBuyCallForPriceProductsEnabled',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsAllowAdminToBuyCallForPriceProductsEnabled}
                />
                <InputContainer
                    label="Allow Vendor To Accept Orders Enabled"
                    name="IsAllowVendorToAcceptOrdersEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsAllowVendorToAcceptOrdersEnabled',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsAllowVendorToAcceptOrdersEnabled}
                />
                <InputContainer
                    label="Allow Generate Payment Link Enabled"
                    name="IsAllowGeneratePaymentLinkEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsAllowGeneratePaymentLinkEnabled',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsAllowGeneratePaymentLinkEnabled}
                /> 
                <InputContainer
                    label="Accept Order By Default"
                    name="IsAcceptOrderByDefault"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'OrderSettings.IsAcceptOrderByDefault',
                        selectDOMSettings?.OrderSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.OrderSettings?.IsAcceptOrderByDefault}
                />   
            </div>
            }
        expandedPanel="Order Settings"
        headerTitle="Order Settings"
        />
        </>
  )
}
export default DOMOrderSettingsComponent;
